import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: enrolments.NZCredential.
export default class CredentialNz extends Fragment {
  declare [Type]: 'enrolments/credential-nz';

  // service specifies the New Zealand service these credentials are for.
  @attr('number', { defaultValue: 0 })
  declare service: number;

  // enrolId is the unique school identifier provided from ENROL in order
  // to authenticate the school to the ENROL API.
  @attr('number', { defaultValue: 0 })
  declare enrolId: number;

  // password is the password provided from ENROL in order to authenticate the school to the ENROL API
  @attr('string', { defaultValue: '' })
  declare password: string;
}
